import React, { useEffect, useState } from "react";
import { Modal, Form, Row, Col, Input, InputNumber, message, Select } from "antd";

import { IBehavior, IBehaviorForm, IBehaviorType } from "./types";
import { FormComponentProps } from "antd/lib/form";
import { getDataById, saveOrUpdate, select } from "../actions/dimensionsAndType";
import { QmFormLoading } from "../../../components/QmLoading/formLoading";
import { Utilitaries } from "../../../business";

const { TextArea } = Input;
const { Option } = Select;

const formName = "qa_tipos_param_comp.xml";
const listName = "tipo_param_comportam";

interface IProps extends FormComponentProps {
    record?: IBehavior;
    onClose: (reload?: boolean) => void;
}

function FormCompetence({ onClose, record, form }: IProps) {
    const [isSaving, setIsSaving] = useState(false);
    const [behaviorTypeList, setBehaviorTypeList] = useState<IBehaviorType[]>([]);
    const [loadingTypes, setLoadingTypes] = useState(true);

    const [initialData, setInitialData] = useState<{ loading: boolean; data: IBehaviorForm | null }>({
        loading: true,
        data: null,
    });

    const { getFieldDecorator } = form;

    useEffect(() => {
        if (!record) {
            setInitialData((state) => ({
                ...state,
                loading: false,
            }));
            return;
        }

        getDataById(listName, record?.id_tipo_parametros_comportam)
            .then((response) => {
                if (response.tipo_parametros_comportam) {
                    const data = response.tipo_parametros_comportam as IBehaviorForm;
                    setInitialData({
                        loading: false,
                        data: {
                            ...data,
                            designacao: typeof data.designacao === "object" ? "" : data.designacao,
                            descricao: typeof data.descricao === "object" ? "" : data.descricao,
                            n_inc_cri_neg: typeof data.n_inc_cri_neg === "object" ? "" : data.n_inc_cri_neg,
                            n_inc_cri_posi: typeof data.n_inc_cri_posi === "object" ? "" : data.n_inc_cri_posi,
                            n_sugests: typeof data.n_sugests === "object" ? "" : data.n_sugests,
                            tipo_comportamento:
                                typeof data.tipo_comportamento === "object" ? "" : data.tipo_comportamento,
                        },
                    });
                } else {
                    message.error("Ocorreu um erro");
                    onClose();
                }
            })
            .catch(() => {
                message.error("Ocorreu um erro");
                onClose();
            });
    }, [record, onClose]);

    useEffect(() => {
        select({
            accao: "lista",
            lista: "tipos_comportamentos",
            pagina: 1,
            resultados_pagina: 0,
        })
            .then((response) => {
                const list: IBehaviorType[] = Utilitaries.toArray(response.linha);
                const data = list.map((item) => ({
                    ...item,
                    designacao: typeof item.designacao === "object" ? "" : item.designacao,
                    descricao: typeof item.descricao === "object" ? "" : item.descricao,
                }));
                setBehaviorTypeList(data);
                setLoadingTypes(false);
            })
            .catch(() => {
                message.error("Erro ao carregar os tipos de conhecimentos");
                onClose();
            });
    }, [onClose]);

    function handleOk() {
        form.validateFields((err, values) => {
            if (!err) {
                setIsSaving(true);
                const objToSave = { ...values };

                if (record) {
                    objToSave.id_tipo_parametros_comportam = record.id_tipo_parametros_comportam;
                }

                const data = JSON.stringify({
                    tipo_parametros_comportam: {
                        ...objToSave,
                        activo: true,
                    },
                });

                saveOrUpdate({
                    accao: "guardar",
                    formulario: formName,
                    dados: data,
                })
                    .then((sucess) => {
                        if (sucess) {
                            message.success("Guardado");
                            onClose(true);
                        } else {
                            message.error("Ocorreu um erro");
                            setIsSaving(false);
                        }
                    })
                    .catch(() => {
                        message.error("Ocorreu um erro");
                        setIsSaving(false);
                    });
            }
        });
    }

    const isLoadingData = initialData.loading;

    const customProps = isLoadingData
        ? {
              footer: null,
          }
        : {};

    const formData = initialData.data;

    return (
        <Modal
            style={{ top: 10 }}
            title={record ? "Editar comportamento" : "Novo comportamento"}
            visible
            onOk={handleOk}
            onCancel={() => onClose()}
            width="50%"
            confirmLoading={isSaving}
            {...customProps}
        >
            {isLoadingData ? (
                <QmFormLoading />
            ) : (
                <Form layout="vertical" onSubmit={handleOk}>
                    <Row gutter={18}>
                        <Col xs={24} sm={24} md={24}>
                            <Form.Item label="Designação">
                                {getFieldDecorator("designacao", {
                                    initialValue: formData?.designacao,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obrigatório",
                                        },
                                    ],
                                })(<Input name="designacao" placeholder="Introduza a designação" />)}
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24}>
                            <Form.Item label="Tipo de conhecimento">
                                {getFieldDecorator("tipo_comportamento", {
                                    initialValue: formData?.tipo_comportamento,
                                })(
                                    <Select
                                        showSearch
                                        allowClear
                                        optionFilterProp="children"
                                        loading={loadingTypes}
                                        filterOption={(input, option) => {
                                            if (option.props.children === undefined || option.props.children === null) {
                                                return false;
                                            }

                                            return (
                                                option.props.children
                                                    .toString()
                                                    ?.toLowerCase()
                                                    .indexOf(input.toLowerCase()) >= 0
                                            );
                                        }}
                                    >
                                        {behaviorTypeList.map((item) => (
                                            <Option key={item.id_tipo_comportamento}>{item.designacao}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24}>
                            <Form.Item label="Descrição">
                                {getFieldDecorator("descricao", {
                                    initialValue: formData?.descricao,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obrigatório",
                                        },
                                    ],
                                })(<TextArea name="descricao" rows={4} />)}
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                            <Form.Item label="Nº Inc. Nega.">
                                {getFieldDecorator("n_inc_cri_neg", {
                                    initialValue: formData?.n_inc_cri_neg,
                                })(<InputNumber min={0} style={{ width: "100%" }} />)}
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                            <Form.Item label="Nº Inc. Posi.">
                                {getFieldDecorator("n_inc_cri_posi", {
                                    initialValue: formData?.n_inc_cri_posi,
                                })(<InputNumber min={0} style={{ width: "100%" }} />)}
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                            <Form.Item label="Nº Sugestões">
                                {getFieldDecorator("n_sugests", {
                                    initialValue: formData?.n_sugests,
                                })(<InputNumber min={1} style={{ width: "100%" }} />)}
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            )}
        </Modal>
    );
}

export const WrappedFormBehavior = Form.create<IProps>({
    name: "form_competence",
})(FormCompetence);

// class FormBehavioralParametersType extends Component {
//     state = {
//         loading: false,
//     };

//     handleResponse = (response) => {
//         this.setState({ loading: false });
//         if (response) {
//             message.success("Guardado com sucesso");
//             this.props.handleOk();
//         } else message.error("Ocorreu um erro");
//     };

//     handleOk = (e) => {
//         this.props.form.validateFields((err, values) => {
//             if (!err) {
//                 this.setState({ loading: true });
//                 if (this.props.isEdit) {
//                     values.id_tipo_parametros_comportam =
//                         this.props.formBehavioralParameter.id_tipo_parametros_comportam;
//                     this.props.update({ formulario: this.props.formulario, values }).then((response) => {
//                         this.handleResponse(response);
//                     });
//                 } else {
//                     this.props.insert({ formulario: this.props.formulario, values }).then((response) => {
//                         this.handleResponse(response);
//                     });
//                 }
//             }
//         });
//     };

//     render() {
//         const title = this.props.isEdit
//             ? "Novo tipo de parâmetro de comportamento"
//             : "Editar tipo de parâmetro de comportamento";
//         const { getFieldDecorator } = this.props.form;
//         return (
//             <Modal
//                 title={title}
//                 visible={this.props.isVisible}
//                 onOk={this.handleOk}
//                 onCancel={this.props.handleCancel}
//                 width="50%"
//                 confirmLoading={this.state.loading}
//             >
//                 <Form layout="vertical" onSubmit={this.handleOk}>
//                     <Row gutter={18}>
//                         <Col xs={24} sm={24} md={24}>
//                             <Form.Item label="Designação">
//                                 {getFieldDecorator("designacao", {
//                                     rules: [
//                                         {
//                                             required: true,
//                                             message: "Campo obrigatório",
//                                         },
//                                     ],
//                                 })(<Input name="designacao" placeholder="Introduza a designação" />)}
//                             </Form.Item>
//                         </Col>
//                         <Col xs={24} sm={24} md={24}>
//                             <Form.Item label="Descrição">
//                                 {getFieldDecorator("descricao", {
//                                     rules: [
//                                         {
//                                             required: true,
//                                             message: "Campo obrigatório",
//                                         },
//                                     ],
//                                 })(<TextArea name="descricao" rows={4} />)}
//                             </Form.Item>
//                         </Col>
//                         <Col xs={24} sm={24} md={8}>
//                             <Form.Item label="Nº Inc. Nega.">
//                                 {getFieldDecorator("n_inc_cri_neg")(<InputNumber min={0} style={{ width: "100%" }} />)}
//                             </Form.Item>
//                         </Col>
//                         <Col xs={24} sm={24} md={8}>
//                             <Form.Item label="Nº Inc. Posi.">
//                                 {getFieldDecorator("n_inc_cri_posi")(<InputNumber min={0} style={{ width: "100%" }} />)}
//                             </Form.Item>
//                         </Col>
//                         <Col xs={24} sm={24} md={8}>
//                             <Form.Item label="Nº Sugestões">
//                                 {getFieldDecorator("n_sugests")(<InputNumber min={1} style={{ width: "100%" }} />)}
//                             </Form.Item>
//                         </Col>
//                     </Row>
//                 </Form>
//             </Modal>
//         );
//     }
// }

// const mapDispatchToProps = {
//     setField: actionCreators.setField,
//     insert: actionCreators.insert,
//     update: actionCreators.update,
// };

// const mapStateToProps = (state, ownProps) => {
//     return {
//         formBehavioralParameter: ownProps.isEdit
//             ? state.behavioralParameter.domain.formEdit
//             : state.behavioralParameter.domain.formCreate,
//         formulario: state.behavioralParameter.domain.metadata.formulario,
//     };
// };

// const formCreate = Form.create({
//     mapPropsToFields(props) {
//         return {
//             designacao: Form.createFormField({
//                 ...props.formBehavioralParameter.designacao,
//                 value: props.formBehavioralParameter.designacao.value,
//             }),
//             descricao: Form.createFormField({
//                 ...props.formBehavioralParameter.descricao,
//                 value: props.formBehavioralParameter.descricao.value,
//             }),
//             n_inc_cri_neg: Form.createFormField({
//                 ...props.formBehavioralParameter.n_inc_cri_neg,
//                 value: props.formBehavioralParameter.n_inc_cri_neg.value,
//             }),
//             n_inc_cri_posi: Form.createFormField({
//                 ...props.formBehavioralParameter.n_inc_cri_posi,
//                 value: props.formBehavioralParameter.n_inc_cri_posi.value,
//             }),
//             n_sugests: Form.createFormField({
//                 ...props.formBehavioralParameter.n_sugests,
//                 value: props.formBehavioralParameter.n_sugests.value,
//             }),
//         };
//     },
//     onFieldsChange(props, fields) {
//         props.setField({ isEdit: props.isEdit, fields });
//     },
// });

// export default connect(mapStateToProps, mapDispatchToProps)(formCreate(FormBehavioralParametersType));
